<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "BaseFooter",
  
})
</script>
<template>
    <div ref="footDom" class="footer" :class="{ isWhite }">
        <div :class="['l-button', { active: currentTab === index }]" v-for="(item, index) in tabMenu" :key="item.title" @click="tab(item, index)">
            <div class="footer-tab">
                <div class="icon-wrap">
                    <img class="footer-icon" :src="getImg(item, currentTab === index)" />
                    <div v-if="index === 2 && initTab === 2" class="sg"></div>
                </div>
                <span class="footer-name" :class="{ active: currentTab === 2 }">{{ $t(item.title) }}</span>
                <div v-if="index === 2 && initTab === 2" class="star"></div>
            </div>
            <transition name="grow">
                <div class="grow-line" v-show="currentTab === index"></div>
            </transition>
        </div>
    </div>
</template>
<script setup lang="ts" name="BaseFooter">
import { useI18n } from 'vue-i18n'

const path = '../assets/img/footer-bar/'
const file = import.meta.glob('../assets/img/footer-bar/*', { eager: true })
import { Log } from '@/api/log'

const i18n = useI18n()

const props = defineProps({
    initTab: {
        type: Number,
        default: () => 0,
    },
    isWhite: {
        type: Boolean,
        default: () => false,
    },
})
const router = useRouter()
const isRefresh = reactive<{
    [key: string]: boolean
    isRefresh1: boolean
    isRefresh2: boolean
}>({
    isRefresh1: false,
    isRefresh2: false,
})
// 当前显示的tab记录
const currentTab = ref(props.initTab)
const footDom = ref(null)
// tab数据
const tabMenu = [
    {
        title: 'Home_page',
        path: '/',
        icon: 'home',
        isFresh: true,
    },
    {
        title: 'Home_Reels',
        path: '/video',
        icon: 'video',
    },
    {
        title: 'earn_money',
        path: '/earnCash',
        icon: 'earncash',
    },
    {
        title: 'Home_Wallets',
        path: '/wallets',
        icon: 'wallets',
    },
    {
        title: 'Home_events',
        path: '/events',
        icon: 'events',
    },
]
// 跳转tab
const tab = (item, index) => {
    Log({
        event: `tab_${i18n.t(item.title)}`,
    })
    // 如果有刷新功能，并且是点击的当前tab
    if (item.isFresh && currentTab.value === index) {
        refresh(index)
    } else {
        if (item.path === '/earnCash') {
            Log({
                event: 'tab_earn',
            })
        }
        router.push(item.path)
    }
}
// 刷新页面
const refresh = (index) => {
    isRefresh['isRefresh' + index] = !isRefresh['isRefresh' + index]
    setTimeout(() => {
        isRefresh['isRefresh' + index] = !isRefresh['isRefresh' + index]
    }, 2000)
}
const getImg = (item, active = false) => {
    return file[path + `${active ? item.icon + '_active' : item.icon}.png`].default
}
const getFootReact = () => {
    return footDom.value.getBoundingClientRect()
}

defineExpose({
    getFootReact,
})
</script>
<style scopes lang="scss">
.footer {
    font-size: 25px;
    position: fixed;
    left: 0;
    width: 100%;
    height: var(--footer-height);
    border-top: 2px solid #3d3b38;
    z-index: 100;
    //不用bottom：0是因为，在进行页面切换的时候，vue的transition
    // 会使footer的bottom：0失效，不能准确定位
    top: calc(100% - var(--footer-height));
    display: flex;
    background: url('@/assets/img/footer-bar/bg.png') no-repeat;
    background-size: 100% 100%;
    border-radius: 20px 20px 0px 0px;

    &::before {
        position: absolute;
        top: -40px;
        left: 30px;
        content: '';
        width: 390px;
        height: 86px;
        pointer-events: none;
        background: url('@/assets/img/footer-bar/line.png') no-repeat;
        background-size: 100% 100%;
    }

    &.isWhite {
        background: white !important;
        color: #000 !important;
    }

    .l-button {
        flex: 1;
        padding-top: 30px;
        position: relative;
        .footer-tab {
            @apply flex flex-col justify-center items-center;
            position: relative;
        }
        .icon-wrap {
            position: relative;

            .sg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                background: url('@/assets/img/footer-bar/animate/s-0.png') no-repeat;
                background-size: 100% 100%;
                animation: sg 6s steps(8) infinite;
            }
        }
        .footer-icon {
            width: 68px;
        }
        .footer-name {
            font-size: 18px;
            margin-top: 11px;
            font-weight: 1000;
            color: #fa3374;
        }
        &:nth-child(4) {
            .footer-name {
                margin-top: 14px;
            }
        }

        &.active {
            .footer-name {
                color: #fff;
            }
        }
    }
    .chrimas-btn {
        display: none;
    }
    &.isChrismas {
        .active {
            .grow-line {
                background: url('@/assets/img/cash_back/slider.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        .chrimas-btn {
            position: absolute;
            top: -55px;
            left: 0;
            display: block;
            width: 100%;
            height: 87px;

            background: url(@/assets/img/cash_back/snow.png) no-repeat;
            background-size: 100% 100%;

            .chrimas-tree {
                position: absolute;
                top: 0;
                left: 50%;
                width: 142px;
                height: 153px;
                background: url(@/assets/img/cash_back/tree.png) no-repeat;
                background-size: 100% 100%;

                transform: translate3d(-50%, -65%, 0);

                .chrimas-tree-light {
                    pointer-events: none;
                    width: 100%;
                    height: 100%;
                    animation: doOpacity 1s ease infinite;
                }
                .chrimas-tree-text {
                    position: absolute;
                    bottom: 5px;
                    left: 50%;
                    width: 118px;
                    height: 23px;
                    transform: translate3d(-50%, 0, 0);
                }
            }
        }
    }
}
@keyframes doOpacity {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
}
// .grow-line {
//     position: absolute;
//     top: -6px;
//     left: 50%;
//     width: 100px;
//     height: 12px;
//     margin-left: -50px;
//     background-image: linear-gradient(150deg, #ffc44f 0%, #ffb944 40%, #ffad38 100%), linear-gradient(#ffffff, #ffffff);
//     background-blend-mode: normal, normal;
//     border-radius: 6px;
//     transform-origin: center center;
//     z-index: 1;
// }
.footer-tip {
    position: absolute;
    top: -15px;
    right: 0px;
    color: rgb(171, 241, 75);
    font-weight: bold;
    font-size: 20px;
}
.star {
    position: absolute;
    left: 0;
    right: 0;
    width: 154px;
    height: 154px;
    background: url('@/assets/img/footer-bar/animate/0.png') no-repeat;
    background-size: 100% 100%;
    animation: starts 2s steps(15) infinite;
}
@keyframes starts {
    @for $i from 0 through 14 {
        #{$i * 7}% {
            background-image: url('@/assets/img/footer-bar/animate/#{$i}.png');
        }
    }
}
@keyframes sg {
    @for $i from 0 through 7 {
        #{$i * 2}% {
            opacity: 1;
            background-image: url('@/assets/img/footer-bar/animate/s-#{$i}.png');
        }
        15% {
            opacity: 0;
            background-image: url('@/assets/img/footer-bar/animate/s-7.png');
        }
        100% {
            opacity: 0;
            background-image: url('@/assets/img/footer-bar/animate/s-7.png');
        }
    }
}
</style>
